import React from 'react';
import { ClassValue } from 'classnames/types';
import BaseInput, { BaseInputPropsWithoutChildren } from './BaseInput';
import styles from './Input.module.scss';

type InputProps = {
  inputRef?: React.Ref<HTMLInputElement>;
} & BaseInputPropsWithoutChildren &
  Required<Pick<BaseInputPropsWithoutChildren, 'label' | 'onChange'>>;

// Aliases for backwards compatibility
export type BaseInputAttributes = BaseInputPropsWithoutChildren;
export type InputAttributes = InputProps;
export type InputTypes = InputProps['type'];

const Input: React.FunctionComponent<InputProps> = ({
  type = 'text',
  className,
  inputRef,
  iconColor = 'gray500',
  ...props
}) => {
  const classNames: ClassValue = [];

  if (!!props.readonly) {
    classNames.push(styles.input__readonly);
  }

  if (!!className) {
    classNames.push(className);
  }

  return (
    <BaseInput
      type={type}
      className={classNames}
      ref={inputRef}
      iconColor={iconColor}
      {...props}
    />
  );
};

export default Input;
